export default __webpack_public_path__ + "static/media/banner_mob_amarelo_2.a9eed520.jpg";